// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  guestHomepage: {
    name: 'guest-homepage',
    componentName: 'GuestHomepageContainer',
    chunk: () =>
      import(
        /* webpackChunkName: 'guest-homepage' */
        './pages/guest-homepage/GuestHomepageContainer'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak(
              '@cwd/src/pages/guest-homepage/GuestHomepageContainer'
            )
          ).GuestHomepageContainer
        : currentRouteName === 'guest-homepage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.GuestHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  consumerHomepage: {
    name: 'consumer-homepage',
    componentName: 'ConsumerHomepageContainer',
    chunk: () =>
      import(
        /* webpackChunkName: 'consumer-homepage' */
        './pages/consumer-homepage/ConsumerHomepageContainer'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak(
              '@cwd/src/pages/consumer-homepage/ConsumerHomepageContainer'
            )
          ).ConsumerHomepageContainer
        : currentRouteName === 'consumer-homepage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ConsumerHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  proHomepage: {
    name: 'pro-homepage',
    componentName: 'ProHomepageContainer',
    chunk: () =>
      import(
        /* webpackChunkName: 'pro-homepage' */
        './pages/pro-homepage/ProHomepageContainer'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak(
              '@cwd/src/pages/pro-homepage/ProHomepageContainer'
            )
          ).ProHomepageContainer
        : currentRouteName === 'pro-homepage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ProHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  eprocurementHomepage: {
    name: 'eprocurement-homepage',
    componentName: 'EProcurementHomepageContainer',
    chunk: () =>
      import(
        /* webpackChunkName: 'eprocurement-homepage' */
        './pages/eprocurement-homepage/EProcurementHomepageContainer'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak(
              '@cwd/src/pages/eprocurement-homepage/EProcurementHomepageContainer'
            )
          ).EProcurementHomepageContainer
        : currentRouteName === 'eprocurement-homepage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.EProcurementHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  exchangeHomepage: {
    name: 'exchange-homepage',
    componentName: 'ExchangeHomepageContainer',
    chunk: () =>
      import(
        /* webpackChunkName: 'exchange-homepage' */
        './pages/exchange-homepage/ExchangeHomepageContainer'
        ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak(
            '@cwd/src/pages/exchange-homepage/ExchangeHomepageContainer'
          )
        ).ExchangeHomepageContainer
        : currentRouteName === 'exchange-homepage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ExchangeHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  }
});
